export const ua = {
  /**
   * 检测是否是微信
   */
  isWeiXin: function () {
    return /MicroMessenger/i.test(navigator.userAgent)
  },
  /**
   * 检测是否Android平台
   * @returns {boolean}
   */
  isAndroid: function () {
    return /Android/i.test(navigator.userAgent)
  },
  /**
   * 检测是否iOS平台
   * @returns {boolean}
   */
  isiOS: function () {
    return /iP(ad|hone|od)/.test(navigator.userAgent)
  },
  /**
   * 检测是否通过浏览器访问
   * @returns {boolean}
   */
  isBrowser: function () {
    return !this.isNative()
  },
  /**
   * 检测是否通过WebView访问
   * @returns {boolean}
   */
  isNative: function () {
    return /WebView/i.test(navigator.userAgent)
  },

  isAomiApp: function () {
    return /AomiApp/i.test(navigator.userAgent)
  },
  isWeBiteApp: function () {
    return /macaupay/i.test(navigator.userAgent)
  },
  isWeiXinMiniProgram: function () {
    return this.isWeiXin() && /miniprogramhtmlwebview/i.test(navigator.userAgent)
  },
  isMiniProgram: function () {
    return this.isWeiXinMiniProgram()
  },
}
